import { useTranslation } from 'react-i18next';

import { SectionField } from '@/components/SectionField/SectionField';

type Props = {
	label: string;
	value: number | string | null | undefined;
	name: string;
};

export const FormReadOnlyField = ({ label, value: v }: Props) => {
	const { t } = useTranslation();

	const value =
		typeof v === 'number' || (typeof v === 'string' && v.length > 0) ? v : '-';

	return (
		<SectionField
			label={t(label)}
			value={value.toString()}
			labelWidth={200}
			hideLabel={label === ''}
			collapseAt='sm'
		/>
	);
};
